module.exports = __webpack_public_path__ + "img/logo1@2x.0227ca37.png";